/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { shape, string } from 'prop-types';
import React from 'react';
import { useQuery } from '@apollo/client';
import findContent from '../../../gql/queries/findContent';
import GraphqlContactUsPage from './GraphqlContactUsPage';

const GraphqlContactUsPageContainer = ({
    brand,
    page,
}) => {
    const CONTACT_US_QUERY = findContent({
        brand: brand['domain-name'],
        contentType: page.contentType,
    });
    const { data, error, loading } = useQuery(CONTACT_US_QUERY);

    if (loading) {
        return null;
    }

    if (error) {
        return null;
    }

    const contactUsData  = data?.findContent?.content?.entries?.[0];
    if (contactUsData) {
        return (
            <GraphqlContactUsPage
                contactUsData={contactUsData}
            />
        );
    }
    return null;
};

GraphqlContactUsPageContainer.propTypes = {
    brand: shape({
        'domain-name': string,
    }).isRequired,
    page: shape({
        contentType: string,
    }).isRequired,
};

export default GraphqlContactUsPageContainer;
